import { SvgIcon } from '@mui/material';

const Edit = ({ ...props }) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
    <path d="M0 15.9844H4.34759L16 4.33192L11.6524 -0.015625L0 11.6368V15.9844ZM1.60723 14.3771V12.2957L3.68857 14.3771H1.60723ZM2.74036 11.1627L9.6434 4.25957L11.7247 6.34096L4.8217 13.244L2.74036 11.1627ZM13.7338 4.33192L12.8579 5.20788L10.7765 3.12649L11.6524 2.25053L13.7338 4.33192Z" />
  </SvgIcon>
);

export default Edit;
